<form class="filter" #formElement [formGroup]="form">
  <mat-form-field class="margin-right-small">
    <input matInput autocomplete="off" formControlName="MedicalAppointmentDate" [matDatepicker]="pickerFrom" placeholder="Fecha turno">
    <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
    <mat-datepicker #pickerFrom></mat-datepicker>
  </mat-form-field>
  <mat-form-field class="medium-width">
    <mat-label>Protocolo</mat-label>
    <input type="text" matInput formControlName="Protocol">
  </mat-form-field>
  <mat-form-field class="medium-width">
    <mat-label>Número</mat-label>
    <input type="number" matInput formControlName="Number">
  </mat-form-field>
  <div class="full-width">
    <patient-autocomplete formControlName="Patient"></patient-autocomplete>
  </div>
</form>
